
<div class="justify-center py-24 px-10 m-auto max-w-screen-lg">
  <h1 class="text-3xl md:text-4xl mb-10 font-light">
    Impressum
  </h1>
  <p>
    BACKAPP CREW GmbH<br>
    c/o TOPDOWN CREATIVE FACTORY GMBH<br>
    Technologiezentrum Eisenstadt, Marktstraße 3<br>
    7000 Eisenstadt
  </p>
  <p>
    Firmenbuchnummer: FN 544004 g<br>
    UID: ATU76351706
  </p>
  <p>
    <a href="/assets/doktordoktor-agb.pdf" target="_blank"><u>Allgemeine Geschäftsbedingungen</u></a><br>
    <a href="/assets/doktordoktor-datenschutz.pdf" target="_blank"><u>Informationen zum Datenschutz</u></a>
  </p>
  <p >
    <a href="/">
      <span class="material-icons text-primary">public</span>&nbsp;
      <u>www.doktordoktor.at</u>
    </a>
  </p>
  <p >
    <a href="tel:+43 2682 93089 450">
      <span class="material-icons text-primary">call</span>&nbsp;
      <u>+43 2682 93089-450</u>
    </a>
  </p>
  <p>
    <a  href="mailto:office@doktordoktor.at">
        <span class="material-icons text-primary">email</span>&nbsp;
        <u>office@doktordoktor.at</u>
    </a>
  </p>

</div>